import { Button } from 'flowbite-react';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { Drawer } from 'src/components/shared/Drawer';
import { useUserContext } from 'src/context/UserProvider';
import PositionCreationModalFormForRecruiter from './PositionCreationModalFormForRecruiter';
import { useMediaQuery } from '@mui/material';
import { UserExperienceLevelType } from 'types';

const FresherCandidatesHeader = ({ experienceLevelBuckets }: { experienceLevelBuckets: UserExperienceLevelType[] }) => {
	const navigate = useNavigate();
	const isMobile = useMediaQuery('(max-width:960px)');
	const { isAccountManagerLoggedIn } = useUserContext();
	const [openCreatePositionModal, setOpenCreatePositionModal] = useState(false);

	return (
		<div className="flex justify-between items-center py-2 pt-6 sm:pt-[10px] border-b border-[#EBEBF0] dark:border-[#555770] border-solid">
			<div className="text-xl font-semibold text-[#1C1C28] dark:text-white">Talent Acquisition</div>

			<Button
				size="sm"
				color="purplePlaced"
				onClick={() => {
					if (isAccountManagerLoggedIn) {
						navigate('/create-position');
					} else {
						setOpenCreatePositionModal(true);
					}
				}}
			>
				<FaPlus className="mr-2" /> Create Position
			</Button>

			<Drawer
				fullWidth={true}
				backgroundColor="#F7F9FB"
				backDropColor="rgba(0, 0, 0, 0.70)"
				header={
					<div className="px-0 md:px-[14px] pt-6">
						<div className="text-[#004FC4] mx-[16px] font-[400] text-sm md:text-base py-2 md:py-[15px] px-[12px] md:px-[19px] rounded-[8px] bg-[#E5F0FF]">
							Kindly confirm the job details before you proceed with shortlisting candidates.
						</div>
					</div>
				}
				isModal={!isMobile}
				modalMaxWidth="760px"
				isOpen={openCreatePositionModal}
				body={
					<div>
						<PositionCreationModalFormForRecruiter isModal={true} experienceLevelBuckets={experienceLevelBuckets} />
					</div>
				}
				onClose={() => {
					setOpenCreatePositionModal(false);
				}}
			/>
		</div>
	);
};

export default FresherCandidatesHeader;
